import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import PreventClickjacking from './Helper/preventClickjacking';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PreventClickjacking />
    <App />
  </React.StrictMode>
);

reportWebVitals();
